<template>
  <!-- <div
    class="bg-screen"
    @click="nextBlog"
    :style="getBgStyle('background_image_url')"
  > -->
  <div
    class="bg-screen"
    :style="getBgStyle('background_image_url')"
    @dblclick="exitFullScreen"
  >
    <BigScreenLoading v-if="this.isActiveInfoLoading" class="bs-loading" />
    <template v-else>
      <div v-if="showWelcome" class="welcome">
        <img class="title" :src="require(`@assets/bigscreen/title.png`)" />
        <div v-if="activeInfo.weibo_screen_status === 1">
          <div class="pwd-input-wrapper">
            <div class="pwd-input-bg"></div>
            <div class="pwd-input-blur"></div>
            <input
              v-model="pwd"
              class="pwd-input"
              type="password"
              placeholder="请输入密码"
              @keyup="handlePassword"
              @focus="handlePwdFocus"
              @blur="handlePwdBlur"
            />
            <img
              v-if="showGotoBtn"
              class="pwd-input-goto"
              :src="require(`@assets/bigscreen/go.png`)"
              @click="handleEnter"
            />
          </div>
          <div class="pwd-error" v-if="isPwdError">
            <img
              class="pwd-error-info"
              :src="require(`@assets/bigscreen/info.png`)"
            />密码错误，请重新输入
          </div>
        </div>
        <div v-else class="active-status">
          <div>{{ activeStatus }}</div>
        </div>
      </div>
      <div v-else>
        <img class="logo" :src="activeInfo.brand_image_url" />
        <img class="left" :src="activeInfo.left_image_url" />
        <img class="right" :src="activeInfo.right_image_url" />
        <BigScreenLoading
          v-if="this.isCardListFirstLoading"
          class="bs-loading"
        />
        <template v-else>
          <div
            class="blog-container"
            ref="blogContainer"
            v-if="blogs.length >= 6"
          >
            <div class="container-shade" :style="shadeStyle"></div>
            <div class="inner" :style="innerStyle">
              <div class="blog">
                <div
                  class="item item-first"
                  ref="itemFirst"
                  :class="isMovingUp ? 'item-first-move' : ''"
                >
                  <div
                    class="item-bg"
                    :class="isMovingUp ? 'item-first-bg-move' : ''"
                  >
                    <div class="item-linear" />
                    <div class="item-blur" />
                  </div>

                  <BigScreenBlog :blog="blogs[0]"></BigScreenBlog>
                </div>
                <div
                  class="item"
                  :class="isMovingUp ? 'item-second-move' : ''"
                  ref="itemSecond"
                >
                  <div
                    class="item-bg"
                    :class="isMovingUp ? 'item-second-bg-move' : ''"
                  >
                    <div class="item-linear" />
                    <div class="item-blur" />
                  </div>
                  <BigScreenBlog :blog="blogs[1]"></BigScreenBlog>
                </div>
                <div class="item">
                  <div class="item-bg">
                    <div class="item-linear" />
                    <div class="item-blur" />
                  </div>
                  <BigScreenBlog :blog="blogs[2]"></BigScreenBlog>
                </div>
              </div>
            </div>
            <div class="inner2">
              <div class="blog-hide">
                <div
                  class="item item-next"
                  :class="
                    isMovingUp ? 'item-next-transition item-next-move' : ''
                  "
                >
                  <div
                    class="wrapper"
                    :class="isMovingUp ? 'item-next-transition2' : ''"
                  ></div>
                  <div class="item-bg">
                    <div class="item-linear" />
                    <div class="item-blur" />
                  </div>
                  <div class="wrapper-flex">
                    <BigScreenBlog :blog="blogs[3]"></BigScreenBlog>
                  </div>
                </div>
                <div
                  class="item item-next2"
                  :class="
                    isMovingUp ? 'item-next-transition item-next2-move' : ''
                  "
                >
                  <div class="wrapper"></div>
                  <div class="wrapper-flex">
                    <BigScreenBlog :blog="blogs[4]"></BigScreenBlog>
                  </div>
                </div>
                <div
                  class="item item-next3"
                  :class="
                    isMovingUp ? 'item-next-transition item-next3-move' : ''
                  "
                >
                  <div class="wrapper"></div>
                  <div class="wrapper-flex">
                    <BigScreenBlog :blog="blogs[5]"></BigScreenBlog>
                  </div>
                </div>
                <!-- 用于计算高度 -->
                <div class="item item-next-hide" ref="nextItemRef">
                  <div class="wrapper-flex">
                    <BigScreenBlog :blog="blogs[3]"></BigScreenBlog>
                  </div>
                </div>
                <!--  -->
              </div>
            </div>
            <div v-show="!isFullScreen" class="full-screen">
              <div class="full-screen-icon" @click="fullScreen">
                <div class="full-screen-text">展开全屏</div>
              </div>
            </div>
          </div>
        </template>
        <BigScreenSearch :topic="activeInfo.weibo_topic" />
      </div>
    </template>
  </div>
</template>

<script>
import BigScreenBlog from "./BigScreen/BigScreenBlog.vue";
import BigScreenSearch from "./BigScreen/BigScreenSearch.vue";
import BigScreenLoading from "./BigScreen/BigScreenLoading.vue";
import api from "@services/api";
import { getUrlParam } from "@utils/url";
import Cookies from "js-cookie";
import { fullScreen, exitFullScreen } from "../utils/fullScreen";

export default {
  name: "BigScreen",
  components: { BigScreenBlog, BigScreenSearch, BigScreenLoading },
  data() {
    const activeId = getUrlParam("active_id");
    const pwd = Cookies.get("ka_act_pwd_" + activeId) || "";
    let cacheImg = "";
    if (localStorage) {
      cacheImg = localStorage.getItem("bgImg_" + activeId);
    }
    return {
      cacheImg,
      innerStyle: {},
      // nextStyle: {},
      isMovingUp: false,
      swiperInterval: 3500, //微博滚动间隔
      isFullScreen: false,
      //
      isExistPassword: Boolean(pwd), //是否已通过密码校验
      isPwdError: false,
      isInputForcs: false,
      //
      isActiveInfoLoading: true,
      isCardListFirstLoading: false,
      activeInfo: {},
      //
      blogs: [],
      pwd,
      activeId,
      //
      pageSize: 20,
      page: 0,
      blogLists: [],
      blogListApiInterval: 5000, //博文列表接口请求间隔
      myApi: api.baseSilent(),
    };
  },
  computed: {
    activeStatus() {
      const status = this.activeInfo.weibo_screen_status;
      if (status === 1) {
        return "活动进行中";
      } else if (status === 0) {
        return "活动未开始";
      } else if (status === 2) {
        return "活动已结束";
      }
      return "活动不存在";
    },
    shadeStyle() {
      const color = this.activeInfo.background_gradient; // "#182033";
      if (color) {
        return {
          backgroundImage: `linear-gradient(180deg, ${color} 0%, ${color}00 100%)`,
        };
      }
      return {};
    },
    showWelcome() {
      //不存在密码或活动不是进行中
      const status = this.activeInfo.weibo_screen_status;
      return !this.isExistPassword || status !== 1;
    },
    showGotoBtn() {
      return this.isInputForcs || this.pwd;
    },
  },
  mounted() {
    document.addEventListener("fullscreenchange", this.fullscreenchange);
    this.myApi
      .get("/ajax/screen/info?aid=" + this.activeId)
      .then((res) => {
        res = res.data || {};
        if (res.code === 10000) {
          this.activeInfo = res.data;
          document.title = res.data.weibo_screen_name || "微博大屏";
          const bgImg = res.data.background_image_url;
          if (bgImg && localStorage) {
            localStorage.setItem("bgImg_" + this.activeId, bgImg);
          }
          //
          if (this.activeInfo.weibo_screen_status === 1) {
            if (this.isExistPassword) {
              this.getFirstList();
            }
          }
        }
      })
      .finally(() => {
        this.isActiveInfoLoading = false;
      });
  },
  methods: {
    nextBlog(finishedCallback) {
      if (!this.isExistPassword) return;
      // 启动过渡
      const height = this.$refs.nextItemRef.offsetHeight;
      this.isMovingUp = true;
      //向上移动一个blog的高度
      this.innerStyle = {
        transition: "bottom 0.5s",
        bottom: `calc(23.518vh + 1.666vh + ${height}px)`, //23.518vh是最初距离底部的位置，1.666vh是两个blog的间隔
      };
      // this.nextStyle = {
      //   height: `calc(0vh + ${height}px)`,
      // };
      // 复位
      setTimeout(() => {
        let first = this.blogs.shift();
        if (this.blogLists.length > 0) {
          first = this.blogLists.shift();
        }
        this.blogs.push(first);
        this.isMovingUp = false;
        this.innerStyle = {};
        // this.nextStyle = {};
        setTimeout(() => {
          if (typeof finishedCallback === "function") {
            finishedCallback();
          }
        }, 0);
      }, 480);
    },
    getTop(name) {
      const ele = this.$refs[name];
      if (!ele) return 0;
      const rect = ele.getBoundingClientRect();
      return (rect || {}).top || 0;
    },
    handlePassword(e) {
      if (e.keyCode == 13) {
        this.isPwdError = false;
        this.getFirstList();
      } else {
        this.isPwdError = false;
      }
    },
    handleEnter() {
      this.isPwdError = false;
      this.getFirstList();
    },
    getFirstList() {
      this.isCardListFirstLoading = true;
      const params = {
        aid: this.activeId,
        number: this.pageSize, //每页数量
        offset: 0,
        ka_act_pwd: this.pwd,
      };
      this.myApi
        .post("/ajax/screen/wb_list", params)
        .then((res) => {
          res = res.data || {};
          // console.log("wb_list res:", res);
          if (res.code === 43005) {
            this.isPwdError = true;
            if (this.isExistPassword) {
              this.pwd = "";
              this.isExistPassword = false;
              this.isPwdError = false;
            }
          } else if (res.code === 10000) {
            Cookies.set("ka_act_pwd_" + this.activeId, this.pwd, {
              expires: 7,
              domain: ".weibo.cn",
            });
            this.isExistPassword = true;
            //
            this.blogLists = (res.data || {}).data || [];
            // console.log("this.blogLists:", this.blogLists);
            this.page += 1;
            //
            this.initBlogs();
            this.consumeBlogList();
            this.produceBlogList();
          }
        })
        .finally(() => {
          this.isCardListFirstLoading = false;
        });
    },
    initBlogs() {
      if (this.blogLists.length < 6) return;
      this.blogs = [];
      for (let i = 0; i < 6; i++) {
        const blog = this.blogLists.shift();
        this.blogs.push(blog);
      }
    },
    getBgStyle(name) {
      //加载数据期间显示缓存的背景图，用于刷新时展示
      if (this.isActiveInfoLoading && this.cacheImg) {
        return {
          backgroundImage: `url(${this.cacheImg})`,
        };
      }
      //
      const value = this.activeInfo[name];
      if (!value) return {};
      return {
        backgroundImage: `url(${value})`,
      };
    },
    //
    consumeBlogList() {
      // console.log("blogLists.length:", this.blogLists.length);
      if (this.consumeTimer) {
        clearTimeout(this.consumeTimer);
      }
      if (this.activeInfo.weibo_screen_status !== 1) return;
      this.consumeTimer = setTimeout(() => {
        this.nextBlog(() => {
          this.consumeBlogList();
        });
      }, this.swiperInterval);
    },
    //
    produceBlogList() {
      // console.log("produceBlogList,length:", this.blogLists.length);
      if (this.produceBlogListTimer) {
        clearTimeout(this.produceBlogListTimer);
      }
      if (this.activeInfo.weibo_screen_status !== 1) return;
      this.produceBlogListTimer = setTimeout(() => {
        if (this.blogLists.length < 10) {
          this.getBlogList(() => {
            this.produceBlogList();
          });
        } else {
          this.produceBlogList();
        }
      }, this.blogListApiInterval);
    },
    getBlogList(finallyCallback) {
      const params = {
        aid: this.activeId,
        number: this.pageSize, //每页数量
        offset: this.page * this.pageSize,
        ka_act_pwd: this.pwd,
      };
      this.myApi
        .post("/ajax/screen/wb_list", params)
        .then((res) => {
          res = res.data || {};
          // console.log("res:", res);
          if (res.code === 10000) {
            const data = res.data || {};
            const list = data.data || [];
            //到达最后一页
            if (list.length === 0) {
              this.page = 0;
            } //
            else {
              this.page += 1;
              this.blogLists = this.blogLists.concat(list);
              // console.log("blogLists:", this.blogLists);
            }
          } else if (res.code === 43007) {
            //活动结束
            this.activeInfo.weibo_screen_status = 2;
          }
        })
        .finally(() => {
          if (finallyCallback) {
            finallyCallback();
          }
        });
    },
    fullScreen() {
      fullScreen(document.body);
    },
    exitFullScreen() {
      exitFullScreen();
    },
    fullscreenchange() {
      this.isFullScreen = !this.isFullScreen;
    },
    handlePwdFocus() {
      this.isInputForcs = true;
    },
    handlePwdBlur() {
      this.isInputForcs = false;
    },
  },
};
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.bg-screen {
  position: relative;
  height: 100%;
  width: 100%;
  background-color: black;
  // background-image: url("~@assets/bigscreen/bg.png");
  background-size: cover;
  .bs-loading {
    position: fixed;
    z-index: 10;
    top: 40vh;
    left: 0;
    right: 0;
  }
  .logo {
    position: absolute;
    left: 5.555vh;
    top: 4.629vh;
    z-index: 10;
    height: 5.555vh;
  }
  .left {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    z-index: 1;
  }
  .right {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    z-index: 1;
  }
  .blog-container {
    position: absolute;
    z-index: 9;
    top: 15vh;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    overflow: hidden;
    font-size: 0;
    .inner {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 23.518vh;
    }
    .inner2 {
      position: absolute;
      left: 0;
      right: 0;
      top: calc(100% - 23.518vh);
      transition: all 0.5s;
    }
    .container-shade {
      position: absolute;
      width: 61.458vw;
      height: 13.426vh;
      left: 50%;
      z-index: 10;
      top: 0;
      margin-left: -30.729vw;
      // background-image: linear-gradient(180deg, #182033e6 10%, #18203300 100%);
    }
  }
  .blog {
    position: relative;
    display: inline-block;
    width: 61.458vw;
    font-family: PingFangSC-Medium;
    color: #151515;
    letter-spacing: 0;
    line-height: 1.413;
    font-size: 4.259vh;
  }
  .blog-hide {
    position: relative;
    display: inline-block;
    width: 61.458vw;
    font-family: PingFangSC-Medium;
    color: #151515;
    letter-spacing: 0;
    line-height: 1.413;
    font-size: 4.259vh;
  }
  .item {
    // padding: 2.593vh;
    width: 100%;
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: 8;
    overflow: hidden;
    border-radius: 1.852vh;
    margin-top: 1.666vh;

    .item-bg {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(255, 255, 255, 0.6);
      // border-radius: 1.852vh;
      z-index: -1;
      .item-linear {
        position: absolute;
        z-index: 2;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-image: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0.6) 0%,
          rgba(255, 255, 255, 0.5) 100%
        );
      }
      .item-blur {
        position: absolute;
        z-index: 1;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        backdrop-filter: blur(4.851vh);
      }
    }
    .wrapper-flex {
      width: 100%;
      display: flex;
      opacity: 0;
    }
  }
  .inner2 {
    .item-bg {
      opacity: 0;
    }
    .wrapper {
      position: absolute;
      z-index: 1;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(255, 255, 255, 0.5);
      backdrop-filter: blur(1.851vh);
      opacity: 1;
    }
  }
  .item-next-transition {
    // transition: all 0.5s;
    transition-duration: 0.4s, 0.3s, 0.4s, 0.4s, 0.4s, 0.2s;
    transition-property: width, height, top, bottom, margin-left, transform;
    // transition: width 0.5s, height 0.2s, top 0.5s, bottom 0.5s, margin-left 0.5s;
    transition-timing-function: linear;
  }
  .item-next-transition2 {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: linear;
  }
  .item-next-hide {
    position: absolute;
    z-index: 1;
    bottom: -3.981vh;
    width: 100%;
    overflow: hidden;
    opacity: 0;
  }
  .item-next {
    position: absolute;
    z-index: 7;
    bottom: -3.981vh;
    // width: 90%;
    transform: scaleX(90%) scaleY(70%);
    transform-origin: center bottom;
    border-bottom-left-radius: 1.852vh 2.645vh;
    // height: 16vh;
    // margin-left: 5%;
    overflow: hidden;
  }

  .item-next2 {
    position: absolute;
    z-index: 6;
    bottom: -7.592vh;
    width: 84%;
    height: 8vh;
    margin-left: 8%;
    overflow: hidden;
  }
  .item-next3 {
    position: absolute;
    z-index: 5;
    bottom: -7.592vh;
    width: 78%;
    height: 0vh;
    margin-left: 11%;
    overflow: hidden;
    opacity: 0;
  }

  .item-next-move {
    //  width: 100%;
    // margin-left: 0%;
    transform: scaleX(100%) scaleY(100%);
    border-bottom-left-radius: 1.852vh;
    bottom: 0;
    .wrapper {
      opacity: 0;
    }
    .item-bg {
      opacity: 1;
    }
    .wrapper-flex {
      opacity: 1;
    }
  }
  .item-next2-move {
    bottom: -3.981vh;
    width: 90%;
    height: 16vh;
    margin-left: 5%;
  }
  .item-next3-move {
    bottom: -7.592vh;
    width: 84%;
    margin-left: 8%;
    height: 8vh;
    opacity: 1;
  }
  .active-loading {
    position: absolute;
    top: 30.55vh;
    left: 0;
    right: 0;
    bottom: 0;
    color: white;
    z-index: 1;
    font-size: 5vh;
    text-align: center;
  }

  .welcome {
    color: white;
    text-align: center;
    padding-top: 38.51vh;
    .title {
      width: 37.037vh;
      margin-bottom: 4.944vh;
      position: relative;
      left: 0.74vh;
    }
    .pwd-input-wrapper {
      position: relative;
      width: 35.185vh;
      height: 5.555vh;
      border-radius: 5vh;
      margin: 0 auto;
      overflow: hidden;
      .pwd-input-bg {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1;
        background: rgba(255, 255, 255, 0.1);
      }
      .pwd-input-blur {
        position: absolute;
        z-index: 2;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        backdrop-filter: blur(4.851vh);
      }
      .pwd-input {
        position: relative;
        z-index: 3;
        color: white;
        width: 35.185vh;
        height: 5.555vh;
        border-radius: 5vh;
        font-size: 3.037vh;
        padding: 1.38vh 6.48vh 1.38vh 2vh;
        letter-spacing: 0.1em;
        background-color: transparent;
        background-image: linear-gradient(
          133deg,
          rgba(208, 255, 210, 0.11) 0%,
          rgba(141, 179, 255, 0.06) 30%,
          rgba(128, 157, 255, 0.06) 71%,
          rgba(255, 104, 221, 0.15) 100%
        );
        border: none;
      }
      .pwd-input:focus,
      .pwd-input:focus-visible {
        border: none;
        outline: none;
      }
      .pwd-input::placeholder {
        letter-spacing: 0;
        color: rgba(255, 255, 255, 0.5);
        font-size: 2.037vh;
        position: relative;
        top: -0.37vh;
      }

      .pwd-input-goto {
        position: absolute;
        top: 1.38vh;
        right: 2vh;
        z-index: 4;
        width: 2.777vh;
        height: 2.777vh;
        cursor: pointer;
      }
    }

    .pwd-error {
      color: rgba(255, 255, 255, 0.9);
      font-size: 1.85vh;
      margin-top: 1.48vh;
      font-family: PingFangSC-Medium;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      .pwd-error-info {
        width: 2.777vh;
        height: 2.777vh;
        margin-right: 0.74vh;
      }
    }
    .active-status {
      color: rgba(255, 255, 255, 0.9);
      font-size: 3vh;
      margin-top: 3vh;
    }
  }
  .full-screen {
    position: absolute;
    z-index: 10;
    font-size: 1.296vh;
    color: white;
    bottom: 1.111vh;
    right: 3.333vh;
    height: 5vh;
    .full-screen-icon {
      position: absolute;
      z-index: 1;
      right: 0;
      top: 0;
      width: 2.407vh;
      height: 2.407vh;
      background-image: url("~@assets/bigscreen/fullscreen01.png");
      background-size: 100% 100%;
      &:hover {
        background-image: url("~@assets/bigscreen/fullscreen02.png");
        cursor: pointer;
        .full-screen-text {
          opacity: 1;
        }
      }
      .full-screen-text {
        opacity: 0;
        position: absolute;
        z-index: 1;
        left: -2.5vh;
        top: -4.259vh;
        width: 7.407vh;
        height: 2.777vh;
        line-height: 2.777vh;
        text-align: center;
        background: rgba(25, 25, 25, 0.8);
        border-radius: 0.185vh;
      }
    }
  }
}
</style>
